import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import BlogDetail from '../Components/Blog-list/Singleblog';
import Breadcrumbs from '../Components/banner/New-banner';

function Oneblog() {
    return (
        <>
        <Combaintop/>
        <Breadcrumbs/>
        <BlogDetail/>
        <Combainbottom/>
        </>
    );
}

export default Oneblog;
